module.exports = __webpack_public_path__ + "static/image/logo-family/logo_shopping_live@2x.png?853791eb";